import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import WhoWeAre from "@/pages/WhoWeAre";
import WhatWeDo from "@/pages/WhatWeDo";
import Snapshot from "@/pages/Snapshot";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import LocationPage from "@/pages/LocationPage";
import { LOCATION_SLUGS } from "@/data/locationContent";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/who-we-are" element={<WhoWeAre />} />
                        <Route path="/what-we-do" element={<WhatWeDo />} />
                        <Route path="/snapshot" element={<Snapshot />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:slug" element={<BlogArticle />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/thank-you" element={<ThankYou />} />
                        {LOCATION_SLUGS.map((slug) => (
                            <Route
                                key={slug}
                                path={`/${slug}`}
                                element={<LocationPage slug={slug} />}
                            />
                        ))}
                        <Route path="*" element={<Home />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
